import { render, staticRenderFns } from "./VerifyAge.vue?vue&type=template&id=594de064"
import script from "./VerifyAge.vue?vue&type=script&lang=js"
export * from "./VerifyAge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports